import zhData from './_zh';
import hkData from './_hk';
import twData from './_tw';
import enData from './_en';

export default [
  {
    data: zhData,
    validator(value) {
      return /^zh[-_]cn$|^zh$/i.test(value);
    }
  },
  {
    data: hkData,
    validator(value) {
      return /^zh[-_]hk$/i.test(value);
    }
  },
  {
    data: twData,
    validator(value) {
      return /^zh[-_]tw$/i.test(value);
    }
  },
  {
    data: enData,
    validator(value) {
      return /^en|^de|^es|^fr|^it|^ja|^ko|^ru|^pt/i.test(value);
    }
  }
];



// WEBPACK FOOTER //
// ./src/components/DistrictPicker/area/index.js